export default class {
  constructor(width, height) {

  }

  div() {

  }

  image() {

  }

  text() {

  }

  wrapText() {

  }
}